import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { theme } from '../configs/theme';

export const ColumnBox = styled(Box)(() => ({
  display: 'flex',
  flexFlow: 'column',
}));

export const RowBox = styled(Box)(() => ({
  display: 'flex',
  flexFlow: 'row',
}));

export const ColumnBoxWrapper = styled(Box)(() => ({
  display: 'flex',
  background: theme.palette.common.white,
  flexFlow: 'column',
  borderRadius: '8px',
  padding: '1rem',
}));
